import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 24px;
  box-sizing: border-box;
  gap: 28px;
`;

export const FirstContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
`;

export const AgentIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${(props) => props.theme.colors.primaryDarker || '#001740'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.white};
  font-size: 12px;
  font-weight: 700;
`;

export const ModelRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const SecondContainer = styled.div`
  min-height: 80px;
  width: 100%;
  max-width: 750px;
    
  & > div {
    z-index: 1;
    position: relative;  
  } 
`;

export const ThirdContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  width: 100%;
  max-width: 750px;
  justify-content: center;
  justify-items: center;
`;

export const StarterQuestion = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  background: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.border || '#D9D9D9'};
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  min-height: 84px;
  height: 84px;
  max-height: 84px;
  width: 100%;
  max-width: 181.5px;
`;

export const ConversationHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: 24px;
  width: 100%;
  max-width: 750px;
`;

export const ConversationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ConversationHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MessagesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 750px;
  flex: 1;
  min-height: 0;
  padding-right: 8px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: ${(props) => props.theme.colors.lighterGray}
    ${(props) => props.theme.colors.highClearGray};
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.highClearGray};
  }
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.lighterGray};
    border-radius: 3px;
  }
`;

export const MessageBubble = styled.div`
  padding: 16px 12px;
  border-radius: 8px;
  max-width: 85%;
  align-self: ${(props) => (props.$isUser ? "flex-end" : "flex-start")};
  background: ${(props) =>
    props.$isUser
      ? "radial-gradient(77.51% 157.3% at 18.46% 91.07%, #E5F8FF 0%, #FFFFFF 80.17%)"
      : "transparent"};
  box-shadow: ${(props) =>
    props.$isUser ? "2px 2px 8px 1px #0000000F" : "none"};
`;

export const ComponentLabel = styled.div`
  background: ${(props) => props.theme.colors.info || '#52c41a'};
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  margin-bottom: 8px;
  margin-top: 8px;
  width: fit-content;
  display: block;
`;
